module.exports = __webpack_public_path__ + "static/media/009.253a8037.jpg";